/**
 * @Description 图例
 */
import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';
// import { useMethods } from '@lhb/hook';
import { Divider } from 'antd';
import {
  targetStandardShop,
  targetChancepoint,
  targetShops,
  targetMallStandardShop,
  targetMallChancepoint,
  targetMallShops,
  targetSurrounding,
} from '../../ts-config';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import LegendItem from './LegendItem';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import PointNameSwitch from './PointNameSwitch';

const Legend: FC<{
  isMallType,
  legendData,
  mainHeight,
  detail,
  storeChecked,
  surroundingChecked,
  setStandardShopData,
  setChancepointData,
  setFamousBrandData,
  setCompetitorsData,
  setCommonStoreData,
  setCommonRimData,
  isOpenHeatMap,
  modelConfigId,
  setIsOpenGatherClient,
  isShare,
  shareParams,
  rangeType,
  nameMarkerVisible,
  setNameMarkerVisible,
}> = ({
  isMallType,
  legendData,
  mainHeight,
  detail,
  storeChecked,
  surroundingChecked,
  setStandardShopData,
  setChancepointData,
  setFamousBrandData,
  setCompetitorsData,
  setCommonStoreData,
  setCommonRimData,
  isOpenHeatMap,
  modelConfigId,
  setIsOpenGatherClient,
  isShare,
  shareParams,
  rangeType,
  nameMarkerVisible,
  setNameMarkerVisible,
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [legendIconActive, setLegendIconActive] = useState(false);
  const [legendLayerActive, setLegendLayerActive] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const containerRef = useRef<any>(null);

  const legendDataGroup = useMemo(() => {
    // 本品牌门店
    const targetStandardStoreEnum = isMallType ? targetMallStandardShop : targetStandardShop;
    // 机会点
    const targetChancepointEnum = isMallType ? targetMallChancepoint : targetChancepoint;
    const chancepointGroup = legendData?.filter((item: any) => {
      // 门店 || 机会点||集客点
      return targetStandardStoreEnum.includes(item.key) || targetChancepointEnum.includes(item.key) || item.key === 'GATHER_CLIENT';
    });
    // 经营门店
    const targetShopEnum = isMallType ? targetMallShops : (demoForCarModelIds.includes(modelConfigId) ? targetMallShops : targetShops); // demo都在围栏内
    const shopGroup = legendData?.filter((item: any) => targetShopEnum.includes(item.key));
    // 周边配套
    const surroundingGroup = legendData?.filter((item: any) => targetSurrounding.includes(item.key));
    // demo时，将小区放到第二个
    if (demoForCarModelIds.includes(modelConfigId) && surroundingGroup?.length > 1) {
      const targetFirst = surroundingGroup[1];
      const targetSec = surroundingGroup[0];
      surroundingGroup[0] = targetFirst;
      surroundingGroup[1] = targetSec;
    }
    if (demoForCarModelIds.includes(modelConfigId)) { // demo不返回机会点
      return [
        [...shopGroup],
        [...surroundingGroup]
      ];
    }
    return [
      [...chancepointGroup],
      [...shopGroup],
      [...surroundingGroup]
    ].filter(item => Array.isArray(item) && item.length);
  }, [legendData, isMallType, modelConfigId]);

  const maxHeight = useMemo(() => {
    return mainHeight - 180;
  }, [mainHeight]);

  useEffect(() => {
    if (legendIconActive || legendLayerActive) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [legendIconActive, legendLayerActive]);

  useEffect(() => {
    containerRef.current.scrollTop = 0;
  }, [legendIconActive]);

  return (
    <>
      <div
        className={styles.legendCon}
        onMouseEnter={() => {
          setLegendIconActive(true);
          // bigdataFn('b72a6315-116f-4eae-a34b-161c78e75cfa', '详情-地图-移入图例', '点击了详情-地图-移入图例', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
        }}
        onMouseLeave={() => setLegendIconActive(false)}
      >
        <div>
          <IconFont iconHref='iconic_zuzhi' className='fs-20 c-222'/>
        </div>
        <div className='c-222 fs-12 font-weight-500'>图例</div>
      </div>
      {/* 图例列表 */}
      <div
        className={cs(styles.legendListCon, isActive ? styles.isActive : '')}
        onMouseEnter={() => {
          setLegendLayerActive(true);
        }}
        onMouseLeave={() => setLegendLayerActive(false)}
        style={{
          maxHeight: `${maxHeight}px`
        }}
        ref={containerRef}
      >
        <div className='c-333 fs-14 font-weight-500 mb-12'>
          图例
        </div>
        {/* 点位名称 */}
        <PointNameSwitch
          isYouthMap
          checked={nameMarkerVisible}
          onChange={(checked: boolean) => setNameMarkerVisible(checked)}/>
        {
          legendDataGroup?.map((item: any, index: number) => <Fragment key={index}>
            {
              item?.map((targetItem: any, idx: number) => <div key={idx} className='mt-8'>
                <LegendItem
                  item={targetItem}
                  detail={detail}
                  legendData={legendData}
                  storeChecked={storeChecked}
                  surroundingChecked={surroundingChecked}
                  setStandardShopData={setStandardShopData}
                  setChancepointData={setChancepointData}
                  setFamousBrandData={setFamousBrandData}
                  setCompetitorsData={setCompetitorsData}
                  setCommonStoreData={setCommonStoreData}
                  setCommonRimData={setCommonRimData}
                  isOpenHeatMap={isOpenHeatMap}
                  setIsOpenGatherClient={setIsOpenGatherClient}
                  isShare={isShare}
                  shareParams={shareParams}
                  rangeType={rangeType}
                  modelConfigId={modelConfigId}
                />
              </div>)
            }
            {
              index < legendDataGroup?.length - 1 ? <Divider
                style={{
                  marginTop: 8,
                  marginBottom: 8,
                  background: '#eee'
                }}
              /> : <></>
            }
          </Fragment>)
        }
      </div>
    </>
  );
};

export default Legend;
